export enum FeatureToggleKey {
    // Client side
    DEBUG_ANALYTICS_LOGGING = "debug.analyticsLogging",
    DEBUG_EVENT_DATA_LAYER_LOGGING = "debug.eventDataLayerLogging",
    DEBUG_ALGOLIA = "debug.algolia",
    DEBUG_FEATURE_SWITCH_UI = "debug.featureSwitchUi",
    FEATURE_CART_ITEM_PROMOTION_LABEL = "feature.cartItemPromotionLabel",
    FEATURE_WISHLIST_BADGE = "feature.wishlistBadge",
    FEATURE_AUTHORISATION_MODE = "feature.authorisationMode",
    FEATURE_STICKY_ECOMMERCE = "feature.ecommerceSticky",

    // Server side
    FEATURE_NEVERBOUNCE = "neverbounce",
    FEATURE_REVIEWS = "reviews",
    FEATURE_CONTACTFORM_ATTACHMENTS = "contactform-attachments",
    FEATURE_KLARNA_OSM = "klarna-osm",
    FEATURE_WARRANTY_CONFORMANCE = "wad"
}
